import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// GA4 + Google Search Console tag, both configured from Admin > Paramètres
export const Analytics = () => {
  const [cfg, setCfg] = useState(null);
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/seo/settings`).then((r) => setCfg(r.data)).catch(() => setCfg({}));
  }, []);

  useEffect(() => {
    const id = cfg?.ga_measurement_id;
    if (!id || window.__gaLoaded) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { anonymize_ip: true, send_page_view: false });
    window.__gaLoaded = true;
  }, [cfg]);

  useEffect(() => {
    if (window.gtag && cfg?.ga_measurement_id) {
      window.gtag('event', 'page_view', { page_path: location.pathname + location.search, page_location: window.location.href, page_title: document.title });
    }
  }, [location, cfg]);

  if (!cfg?.google_site_verification) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={cfg.google_site_verification} />
    </Helmet>
  );
};
